import React from 'react'
import Lottie from "lottie-react";
import tickAnimation from "./tick.json";
const SuccessPage = () => {
  return (
    <div style={{position:"absolute",left:"50%",top:"50%", transform:"translate(-50%,-50%)",display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column"}}>
        <div style={{width:"200px"}}>
        <Lottie animationData={tickAnimation} loop={false} />
        </div>
        <h1 style={{color:"darkblue",marginBottom:"20px"}}>Thank you for your contribution!!</h1>
        <a href="/cashfree/test/payment" style={{cursor:"pointer"}}>← Back to home</a>
    </div>
  )
}

export default SuccessPage